/**
 * @generated SignedSource<<710fe92877240128e45c936fb5afdb34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementMessageActions_chat_deleteMessage_Mutation$variables = {
  id: string;
};
export type AnnouncementMessageActions_chat_deleteMessage_Mutation$data = {
  readonly deleteMessage: {
    readonly " $fragmentSpreads": FragmentRefs<"AnnouncementMessageActions_chat_messageFragment">;
  };
};
export type AnnouncementMessageActions_chat_deleteMessage_Mutation = {
  response: AnnouncementMessageActions_chat_deleteMessage_Mutation$data;
  variables: AnnouncementMessageActions_chat_deleteMessage_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "messageId",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementMessageActions_chat_deleteMessage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "deleteMessage",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnnouncementMessageActions_chat_messageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementMessageActions_chat_deleteMessage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "deleteMessage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReactionsConnection",
            "kind": "LinkedField",
            "name": "reactions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "senderId",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizationResult",
            "kind": "LinkedField",
            "name": "canUpdate",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizationResult",
            "kind": "LinkedField",
            "name": "canDelete",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2cac5b849514e01053f64f5c95db5c01",
    "id": null,
    "metadata": {},
    "name": "AnnouncementMessageActions_chat_deleteMessage_Mutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementMessageActions_chat_deleteMessage_Mutation(\n  $id: ID!\n) {\n  deleteMessage(input: {messageId: $id}) {\n    ...AnnouncementMessageActions_chat_messageFragment\n    id\n  }\n}\n\nfragment AnnouncementMessageActions_chat_messageFragment on Message {\n  id\n  ...AnnouncementReactionButton_chat_messageFragment\n  deletedAt\n  canUpdate {\n    value\n  }\n  canDelete {\n    value\n  }\n  reactions {\n    edges {\n      node {\n        id\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment AnnouncementReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1e44b74ccc64b61885bb4e49de5a5c5";

export default node;
